<template>

    <navbar-comp class="fixed-top" />
    <sidebar-comp class="sticky-top" />

    <!-- This is where the child routes will be rendered -->

      <router-view />

<!--    <footer-comp class="fixed-bottom" />-->
</template>

<script setup>
import NavbarComp from "@/components/navbar/NavbarComp.vue";
import SidebarComp from "@/components/navbar/SidebarComp.vue";
import axios from "axios";
import { onMounted, onUnmounted, ref } from "vue";

const requests = ref([]);
let intervalId; // ref не нужен

function fetchRequests() {
  axios.get("request_from_landing/")
      .then((response) => {
        requests.value = response.data.results.map((request) => ({
          id: request.id,
          name: request.name,
          phone: request.phone,
          is_resolved: request.is_resolved,
          is_faulty: request.is_faulty,
          created_datetime: request.created_datetime,
          closed_datetime: request.closed_datetime,
        }));

        const newCount = response.data.new_count;
        localStorage.setItem('requests_from_landing', newCount);
        window.dispatchEvent(new CustomEvent('landingRequestsUpdated'));
      })
      .catch((error) => {
        console.error('Failed to fetch landing requests:', error);
      });
}

onMounted(() => {
  fetchRequests();
  intervalId = setInterval(fetchRequests, 10000);
});

onUnmounted(() => {
  clearInterval(intervalId);
});
</script>


<style scoped>
</style>
